import React from 'react';
import PropTypes from 'prop-types';
import styles from './variable.module.scss';
import Newsletter from '../../../molecules/newsletter';

const VariableComponent = ({ pageContext }) => (
  <div className={styles?.variableContainer || ''} >
    <Newsletter page={pageContext?.page} openBtnText="Toggle Newsletter" footer={false} isSticky />
  </div>
);
VariableComponent.propTypes = {
  pageContext: PropTypes.shape({
    page: PropTypes.shape({})
  }),
};

export default VariableComponent;
